import NonVatPayerItemVatStrategy from "@/module/Form/VatDeterminer/VatStrategy/NonVatPayerItemVatStrategy";
import ItemVatDeterminer from "@/module/Form/VatDeterminer/ItemVatDeterminer";
import { VatMode } from "@/module/Form/VatDeterminer/VatMode";
import IdentifiedPersonItemVatStrategy from "@/module/Form/VatDeterminer/VatStrategy/IdentifiedPersonItemVatStrategy";
import VatPayerItemVatStrategy from "@/module/Form/VatDeterminer/VatStrategy/VatPayerItemVatStrategy";
import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";
import FormResource from "@/module/Form/Resources/FormResource";
import ForeignVatProvider from "@/module/Form/ForeignVatProvider/ForeignVatProvider";

export default class ItemVatDeterminerStrategyFactory {
  private readonly foreignCustomerDeterminer: ForeignCustomerDeterminer;
  private readonly foreignVatProvider: ForeignVatProvider;
  private readonly ossMode: number;

  private nonVatPayerStrategy: NonVatPayerItemVatStrategy | null = null;
  private identifiedPersonStrategy: IdentifiedPersonItemVatStrategy | null =
    null;
  private vatPayerStrategy: VatPayerItemVatStrategy | null = null;

  constructor(
    formResource: FormResource,
    foreignCustomerDeterminer: ForeignCustomerDeterminer,
    foreignVatProvider: ForeignVatProvider,
  ) {
    this.foreignCustomerDeterminer = foreignCustomerDeterminer;
    this.foreignVatProvider = foreignVatProvider;
    this.ossMode = Number(
      formResource.settings.use_moss_for_non_vat_payer_eu_companies,
    );
  }

  getStrategy(vatMode: VatMode): ItemVatDeterminer {
    if (vatMode === VatMode.NON_VAT_PAYER) {
      if (this.nonVatPayerStrategy === null) {
        this.nonVatPayerStrategy = new NonVatPayerItemVatStrategy();
      }

      return this.nonVatPayerStrategy;
    }

    if (vatMode === VatMode.IDENTIFIED_PERSON) {
      if (this.identifiedPersonStrategy === null) {
        this.identifiedPersonStrategy = new IdentifiedPersonItemVatStrategy(
          this.ossMode,
          this.foreignCustomerDeterminer,
          this.foreignVatProvider,
        );
      }

      return this.identifiedPersonStrategy;
    }

    if (vatMode === VatMode.VAT_PAYER) {
      if (this.vatPayerStrategy === null) {
        this.vatPayerStrategy = new VatPayerItemVatStrategy(
          this.ossMode,
          this.foreignCustomerDeterminer,
          this.foreignVatProvider,
        );
      }

      return this.vatPayerStrategy;
    }

    throw new Error('Unknown vat strategy "' + vatMode + '".');
  }
}
